import {
  riotTheme,
  lolTheme,
  lorTheme,
  tftTheme,
  valorantTheme,
  wildriftTheme,
  lionTheme,
  createTheme,
  breakpoints as mqBreakpoints,
  ThemeConfig,
} from "@riot-private/ux-react-components";
import { default_theme } from "./theme";

export type ThemeName = "riot" | "lol" | "lor" | "tft" | "valorant" | "wildrift" | "lion" | "error";

export type MediaQuery = keyof typeof mqBreakpoints;

type BreakPoints = { up: (mediaQuery: MediaQuery) => string; down: (mediaQuery: MediaQuery) => string };
export interface ThemeInterface extends Omit<ThemeConfig, "breakpoints"> {
  breakpoints: BreakPoints;
  themeName: ThemeName;
}

const mediaQueries = riotTheme?.mediaQueries || {};

mediaQueries["tablet-lg"] = 1024;

const breakpoints = {
  up: (mediaQuery: MediaQuery) => `@media screen and (min-width: ${mediaQueries[mediaQuery]}px)`,
  down: (mediaQuery: MediaQuery) => `@media screen and (max-width: ${mediaQueries[mediaQuery]}px)`,
};

function createGameTheme(themeName: ThemeName, theme: ThemeConfig) {
  return { themeName, ...default_theme, ...createTheme(theme, "dark"), breakpoints };
}

export const themes = {
  riot: createGameTheme("riot", riotTheme),
  lol: createGameTheme("lol", lolTheme),
  lor: createGameTheme("lor", lorTheme),
  tft: createGameTheme("tft", tftTheme),
  valorant: createGameTheme("valorant", valorantTheme),
  wildrift: createGameTheme("wildrift", wildriftTheme),
  lion: createGameTheme("lion", lionTheme),
  error: createGameTheme("error", riotTheme),
};
